import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import FileViewer from "@/components/FileViewer";
import AppLayout from "@/components/layout/AppLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Reconciliation from "@/pages/Reconciliation";
import CertGenerator from "@/pages/school/CertGenerator";
import ModularDashboard from "@/pages/modular/ModularDashboard";
import Tutors from "@/pages/modular/Tutors";
import Colloqui from "@/pages/modular/Colloqui";
import PortaleTutor from "@/pages/PortaleTutor";
import PagamentiModulare from "@/pages/modular/Pagamenti";
import PortalePagamenti from "@/pages/PortalePagamenti";
import Assicurazione from "@/pages/school/Assicurazione";
import PortaleAssicurazione from "@/pages/PortaleAssicurazione";
import Donors from "@/pages/Donors";
import DonorDetail from "@/pages/DonorDetail";
import Donations from "@/pages/Donations";
import Schedules from "@/pages/Schedules";
import FollowUp from "@/pages/FollowUp";
import LateDonors from "@/pages/LateDonors";
import Communications from "@/pages/Communications";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import UsersManager from "@/pages/UsersManager";
import Permessi from "@/pages/Permessi";
import Health from "@/pages/Health";
import StaffNotifications from "@/pages/StaffNotifications";
import DonationsAudit from "@/pages/DonationsAudit";
import {
  SchoolDashboard, Courses as CoursesOld, Seminars as SeminarsOld,
  Exams as ExamsOld,
} from "@/pages/school/SchoolPages";
import Exams from "@/pages/school/Exams";
import ExamSessionDetail from "@/pages/school/ExamSessionDetail";
import StoricoEsami from "@/pages/school/StoricoEsami";
import AdminDashboard from "@/pages/administration/AdminDashboard";
import Movimenti from "@/pages/administration/Movimenti";
import Casse from "@/pages/administration/Casse";
import Categorie from "@/pages/administration/Categorie";
import ReportAdmin from "@/pages/administration/Report";
import PortalLibretto from "@/pages/PortalLibretto";
import Piano from "@/pages/Piano";
import PracticalCredits from "@/pages/school/PracticalCredits";
import Students from "@/pages/school/Students";
import StudentDetail from "@/pages/school/StudentDetail";
import Attendance from "@/pages/school/Attendance";
import AttendanceSession from "@/pages/school/AttendanceSession";
import AttendanceQR from "@/pages/school/AttendanceQR";
import Teachers from "@/pages/school/Teachers";
import TeacherDetail from "@/pages/school/TeacherDetail";
import Courses from "@/pages/school/Courses";
import CourseDetail from "@/pages/school/CourseDetail";
import Seminars from "@/pages/school/Seminars";
import Requests from "@/pages/Requests";
import RequestDetail from "@/pages/RequestDetail";
import Threads from "@/pages/Threads";
import ThreadDetail from "@/pages/ThreadDetail";
import PortalHome from "@/pages/PortalHome";
import { Navigate } from "react-router-dom";
import { useAuth as useAuthGuard } from "@/lib/auth";

const NoModular = ({ children }) => (useAuthGuard().user?.track_type === "modulare" ? <Navigate to="/portale/bacheca" replace /> : children);
import PortalMaterials from "@/pages/PortalMaterials";
import PortalCourses from "@/pages/PortalCourses";
import PortalCourseDetail from "@/pages/PortalCourseDetail";
import PortalPermessi from "@/pages/PortalPermessi";
import PermessiMonteOre from "@/pages/school/Permessi";
import AssenzeDaGiustificare from "@/pages/school/AssenzeDaGiustificare";
import PortalDocumenti from "@/pages/PortalDocumenti";
import PortalAttestati from "@/pages/PortalAttestati";
import PortalFrequenza from "@/pages/PortalFrequenza";
import HelpDesk from "@/pages/HelpDesk";
import HelpDeskDetail from "@/pages/HelpDeskDetail";
import DocentePortal from "@/pages/docente/DocentePortal";
import DocentePresenze from "@/pages/docente/DocentePresenze";
import DocenteDocumenti from "@/pages/docente/DocenteDocumenti";
import DocumentiCondivisi from "@/pages/school/DocumentiCondivisi";
import SchoolDashboardV2 from "@/pages/school/SchoolDashboardV2";
import StudentStats from "@/pages/school/StudentStats";
import StudentsStatistics from "@/pages/school/StudentsStatistics";
import SchoolSettings from "@/pages/SchoolSettings";
import Checkin from "@/pages/Checkin";
import PublicSeminars from "@/pages/public/PublicSeminars";
import PublicSeminarDetail from "@/pages/public/PublicSeminarDetail";
import SeminarBookings from "@/pages/school/SeminarBookings";
import MansioniCatalogo from "@/pages/mansioni/Catalogo";
import Turni from "@/pages/mansioni/Turni";
import GeneraTurni from "@/pages/mansioni/GeneraTurni";
import StatisticheTurni from "@/pages/mansioni/StatisticheTurni";
import StatisticheImpegni from "@/pages/mansioni/StatisticheImpegni";
import Impegni from "@/pages/mansioni/Impegni";
import Planner from "@/pages/mansioni/Planner";
import StudentiLiberi from "@/pages/mansioni/StudentiLiberi";
import PortaleTurni from "@/pages/PortaleTurni";
import AvvisiAdmin from "@/pages/school/AvvisiAdmin";
import PortaleBacheca from "@/pages/PortaleBacheca";
import PortaleBar from "@/pages/PortaleBar";
import WalletAdmin from "@/pages/wallet/WalletAdmin";
import WalletRicariche from "@/pages/wallet/WalletRicariche";
import BarReport from "@/pages/wallet/BarReport";
import MyWallet from "@/pages/wallet/MyWallet";
import PortalProfile from "@/pages/PortalProfile";
import PortalEsercizi from "@/pages/PortalEsercizi";
import Vigilanza from "@/pages/vigilanza/Vigilanza";
import PublicTurni from "@/pages/public/PublicTurni";
import IscrizioneModulare from "@/pages/public/IscrizioneModulare";
import Iscrizioni from "@/pages/modular/Iscrizioni";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/checkin" element={<Checkin />} />
            <Route path="/seminari" element={<PublicSeminars />} />
            <Route path="/seminari/:id" element={<PublicSeminarDetail />} />
            <Route path="/turni" element={<PublicTurni />} />
            <Route path="/iscrizione-modulare" element={<IscrizioneModulare />} />
            <Route element={<AppLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="donatori" element={<Donors />} />
              <Route path="donatori/:id" element={<DonorDetail />} />
              <Route path="donazioni" element={<Donations />} />
              <Route path="donazioni/cronologia" element={<DonationsAudit />} />
              <Route path="donazioni/riconciliazione" element={<Reconciliation />} />
              <Route path="scadenze" element={<Schedules />} />
              <Route path="followup" element={<FollowUp />} />
              <Route path="donatori-ritardo" element={<LateDonors />} />
              <Route path="comunicazioni" element={<Communications />} />
              <Route path="report" element={<Reports />} />
              <Route path="impostazioni" element={<Settings />} />
              <Route path="impostazioni/utenti" element={<UsersManager />} />
              <Route path="impostazioni/permessi" element={<Permessi />} />
              <Route path="impostazioni/health" element={<Health />} />
              <Route path="impostazioni/notifiche" element={<StaffNotifications />} />
              <Route path="impostazioni/scuola" element={<SchoolSettings />} />

              {/* School module */}
              <Route path="scuola" element={<SchoolDashboardV2 />} />
              <Route path="scuola/piano" element={<Piano />} />
              <Route path="scuola/crediti-pratici" element={<PracticalCredits />} />
              <Route path="scuola/studenti" element={<Students key="res" track="residenziale" />} />
              <Route path="scuola/assicurazione" element={<Assicurazione />} />
              <Route path="modulare" element={<ModularDashboard />} />
              <Route path="modulare/studenti" element={<Students key="mod" track="modulare" />} />
              <Route path="modulare/corsi" element={<Courses key="mod" track="modulare" />} />
              <Route path="modulare/corsi/:id" element={<CourseDetail />} />
              <Route path="modulare/tutor" element={<Tutors />} />
              <Route path="modulare/colloqui" element={<Colloqui />} />
              <Route path="modulare/pagamenti" element={<PagamentiModulare />} />
              <Route path="modulare/iscrizioni" element={<Iscrizioni />} />
              <Route path="modulare/docenti" element={<Teachers key="mod" track="modulare" />} />
              <Route path="modulare/attestati" element={<CertGenerator />} />
              <Route path="modulare/seminari" element={<Seminars />} />
              <Route path="scuola/statistiche" element={<StudentsStatistics />} />
              <Route path="scuola/studenti/:id" element={<StudentDetail />} />
              <Route path="scuola/studenti/:id/statistiche" element={<StudentStats />} />
              <Route path="modulare/studenti/:id" element={<StudentDetail />} />
              <Route path="modulare/studenti/:id/statistiche" element={<StudentStats />} />
              <Route path="scuola/docenti" element={<Teachers key="res" track="residenziale" />} />
              <Route path="scuola/docenti/:id" element={<TeacherDetail />} />
              <Route path="scuola/corsi" element={<Courses key="res" track="residenziale" />} />
              <Route path="scuola/corsi/:id" element={<CourseDetail />} />
              <Route path="scuola/seminari" element={<Seminars />} />
              <Route path="scuola/attestati" element={<CertGenerator />} />
              <Route path="scuola/iscrizioni-seminari" element={<SeminarBookings />} />
              <Route path="scuola/presenze" element={<Attendance />} />
              <Route path="scuola/presenze/:id" element={<AttendanceSession />} />
              <Route path="scuola/assenze-da-giustificare" element={<AssenzeDaGiustificare />} />
              <Route path="scuola/presenze/:id/qr" element={<AttendanceQR />} />
              <Route path="scuola/esami" element={<Exams />} />
              <Route path="scuola/esami/:id" element={<ExamSessionDetail />} />
              <Route path="scuola/storico-esami" element={<StoricoEsami />} />
              <Route path="amministrazione" element={<AdminDashboard />} />
              <Route path="amministrazione/movimenti" element={<Movimenti />} />
              <Route path="amministrazione/casse" element={<Casse />} />
              <Route path="amministrazione/categorie" element={<Categorie />} />
              <Route path="amministrazione/report" element={<ReportAdmin />} />

              {/* Segreteria — Richieste & Messaggi */}
              <Route path="richieste" element={<Requests />} />
              <Route path="richieste/:id" element={<RequestDetail />} />
              <Route path="messaggi" element={<Threads />} />
              <Route path="messaggi/:id" element={<ThreadDetail />} />

              {/* Portale Studente */}
              <Route path="portale" element={<Navigate to="/portale/bacheca" replace />} />
              <Route path="portale/home" element={<PortalHome />} />
              <Route path="portale/richieste" element={<Requests />} />
              <Route path="portale/richieste/:id" element={<RequestDetail />} />
              <Route path="portale/messaggi" element={<Threads />} />
              <Route path="portale/messaggi/:id" element={<ThreadDetail />} />
              <Route path="portale/appelli" element={<Exams />} />
              <Route path="portale/libretto" element={<PortalLibretto />} />
              <Route path="portale/piano" element={<Piano />} />
              <Route path="portale/materiali" element={<PortalMaterials />} />
              <Route path="portale/corsi" element={<PortalCourses key="corsi" />} />
              <Route path="portale/corsi/:id" element={<PortalCourseDetail />} />
              <Route path="portale/seminari" element={<PortalCourses key="seminari" seminars />} />
              <Route path="portale/seminari/:id" element={<PortalCourseDetail />} />
              <Route path="portale/permessi" element={<NoModular><PortalPermessi /></NoModular>} />
              <Route path="scuola/permessi" element={<PermessiMonteOre />} />
              <Route path="portale/documenti" element={<PortalDocumenti />} />
              <Route path="portale/attestati" element={<PortalAttestati />} />
              <Route path="portale/frequenza" element={<PortalFrequenza />} />

              {/* Help Desk */}
              <Route path="helpdesk" element={<HelpDesk />} />
              <Route path="helpdesk/:id" element={<HelpDeskDetail />} />

              {/* Portale Docente */}
              <Route path="docente" element={<DocentePortal />} />
              <Route path="docente/presenze" element={<DocentePresenze />} />
              <Route path="docente/documenti" element={<DocenteDocumenti />} />
              <Route path="scuola/documenti-condivisi" element={<DocumentiCondivisi />} />
              <Route path="docente/presenze/:id" element={<AttendanceSession />} />
              <Route path="docente/presenze/:id/qr" element={<AttendanceQR />} />

              {/* Area Mansioni (admin/segreteria) */}
              <Route path="mansioni" element={<MansioniCatalogo />} />
              <Route path="mansioni/turni" element={<Turni />} />
              <Route path="mansioni/turni/genera" element={<GeneraTurni />} />
              <Route path="mansioni/statistiche" element={<StatisticheTurni />} />
              <Route path="mansioni/statistiche-impegni" element={<StatisticheImpegni />} />
              <Route path="mansioni/impegni" element={<Impegni />} />
              <Route path="mansioni/planner" element={<Planner />} />
              <Route path="mansioni/liberi" element={<StudentiLiberi />} />
              <Route path="wallet" element={<WalletAdmin />} />
              <Route path="wallet/ricariche" element={<WalletRicariche />} />
              <Route path="wallet/bar" element={<BarReport />} />
              <Route path="portale/wallet" element={<MyWallet />} />
              <Route path="portale/bar" element={<PortaleBar />} />
              <Route path="portale/tutor" element={<PortaleTutor />} />
              <Route path="portale/pagamenti" element={<PortalePagamenti />} />
              <Route path="portale/assicurazione" element={<NoModular><PortaleAssicurazione /></NoModular>} />
              <Route path="portale/profilo" element={<PortalProfile />} />
              <Route path="portale/esercizi" element={<PortalEsercizi />} />
              <Route path="docente/wallet" element={<MyWallet />} />

              {/* Portale Studente — turni & impegni */}
              <Route path="portale/turni" element={<NoModular><PortaleTurni /></NoModular>} />
              <Route path="portale/bacheca" element={<PortaleBacheca />} />

              {/* Bacheca avvisi (segreteria) */}
              <Route path="scuola/avvisi" element={<AvvisiAdmin />} />
              <Route path="vigilanza" element={<Vigilanza />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <FileViewer />
      </AuthProvider>
    </div>
  );
}
